import React, { useContext } from "react";
import { Button, message } from "antd";
import { successTitle, successSubtitle } from "../../../pages/Users/styles";
import { CustomIcons } from "../../../assets";
import { Dispatcher } from "../../../util/helpers";
import { usePostResponderAdmin } from "../../../hooks/useAdmin";
import ExistingUserForm from "../../Forms/ExistingUser";
import { copyObjects } from "@/util/copyObjects";
import AuthContext from "@/contexts/AuthContext";

interface ExistingUserTabProp {
  ResponderCompanyId: number | null;
  setCloseDrawer: Dispatcher<boolean>;
  refetchAdmins: () => void;
}

const ExistingUserTab = ({
  ResponderCompanyId,
  setCloseDrawer,
  refetchAdmins,
}: ExistingUserTabProp) => {
  const addResponderAdmin = usePostResponderAdmin();
  const [messageApi, contextHolder] = message.useMessage();
  const messageKey = "createResponderAdmin";
  const user = useContext(AuthContext);
  let isPhoneNumber = false;

  const destroyMessage = () => {
    messageApi.destroy(messageKey);
  };

  const handleAddUser = async (key: string) => {
    if (key.startsWith("+27")) {
      isPhoneNumber = true;
    }

    if (ResponderCompanyId) {
      try {
        messageApi.open({
          key: messageKey,
          type: "loading",
          content: "Creating Responder admin..",
          duration: 0,
        });

        const responderAdmin: IAddResponderAdmin = {
          ResponderCompanyId: ResponderCompanyId || 0,
          emailAddress: isPhoneNumber ? undefined : key,
          phoneNumber: isPhoneNumber ? key : undefined,
        };
        await addResponderAdmin.mutateAsync(responderAdmin);
        refetchAdmins();
        messageApi.open({
          key: messageKey,
          type: "success",
          content: "Created Responder admin..",
          duration: 0,
        });
        setTimeout(() => {
          destroyMessage();
        }, 2000);
      } catch (error) {
        destroyMessage();
      }
    } else {
      message.error("Responder not found");
    }
  };

  const handleClose = async () => {
    setCloseDrawer(false);
    addResponderAdmin.reset();
  };
  return (
    <div>
      {contextHolder}
      {addResponderAdmin.isSuccess ? (
        <div className="flex w-full h-full gap-2 flex-column align-items-center justify-content-center">
          <div className="flex w-full justify-content-center">
            <CustomIcons.SuccessIcon
              width={100}
              height={100}
              viewBox={null}
              svgColor="#179717"
            />
          </div>
          <div style={successTitle}> Successful</div>
          <div style={successSubtitle} className="pb-4">
            {" "}
            You have successfully added a new admin
          </div>
          <Button
            type="primary"
            ghost
            onClick={handleClose}
            size="large"
            className="w-4"
          >
            close
          </Button>
        </div>
      ) : (
        <>
          <ExistingUserForm
            onFormFinish={(key: string) => {
              handleAddUser(key);
            }}
            onModelClose={() => {
              handleClose();
            }}
            isLoading={addResponderAdmin.isPending}
            isSuccess={addResponderAdmin.isSuccess}
          />
        </>
      )}
    </div>
  );
};

export default ExistingUserTab;
